import React from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import { Link, useRouteMatch } from 'react-router-dom';
import ServiceCard from './ServiceCard';
import styles from './ConnectorSettings.module.scss';
import { PanelHeader } from 'js/components';
import { CONNECTOR_SERVICES } from 'js/data/connectors';

function ServiceSelection() {
  const match = useRouteMatch();

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <h2>Add a new connector</h2>
        </div>
      </PanelHeader>
      <div className="content">
        <Card>
          <CardHeader>
            <CardTitle tag="h5">Choose service</CardTitle>
            <p className="text-muted">
              Select the service you want to integrate with to configure the
              connection.
            </p>
          </CardHeader>
          <CardBody>
            <div className={styles['services-list']}>
              {CONNECTOR_SERVICES.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>

            <div className="mt-4 text-right">
              <Link
                to={match.url.replace('/connectors/new', '')}
                className="btn btn-secondary"
              >
                Cancel
              </Link>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default ServiceSelection;
